import React from "react";
import { Create } from "react-admin";
import { EditActions } from "../../common/form/FormActions";
import { RoleForm } from "./RoleForm";
import { useNotification } from "../../../common/hooks/useNotification";

interface IRoleCreateProps {}

export const RoleCreate = (props: IRoleCreateProps) => {
  const notify = useNotification(props, "createSuccess");
  return (
    <Create
      {...props}
      actions={<EditActions />}
      onSuccess={notify}
      title="resources.admin-roles.title.create">
      <RoleForm />
    </Create>
  );
};
